/* eslint-disable */
import * as util from "@/api/agent";
import { getAgentSession, getXAuthAgent, setXAuthAgent, removeXAuthAgent, setAgentSession, removeAgentSession } from "@/utils/auth";

const state = {
    agentSession: (getAgentSession() != null) ? JSON.parse(getAgentSession()) : {},
    x_auth_agent: "",
    fieldsGetAgentList: {
        email: "",
        name: "",
        page: 0,
        perPage: 20
    }

};


const mutations = {
    SET_fieldsGetAgentList: (state, value) => {
        state.fieldsGetAgentList = value
    },
    SET_agentSession: (state, value) => {
        state.agentSession = value
    },
    SET_x_auth_agent: (state, value) => {
        state.x_auth_agent = value
    },
};

const actions = {
    updateAgentRolesOneStored({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.updateAgentRolesOneStored(dataParams).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    deleteAgentRolesOneStored({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.deleteAgentRolesOneStored(dataParams).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getAgentRel({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.getAgentRel(dataParams).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setFieldsGetAgentList({ commit }, data) {
        commit("SET_fieldsGetAgentList", data);
    },
    updatePasswordStored({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.updatePasswordStored(dataParams).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    updateStored({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.updateStored(dataParams).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getAgentById({ commit }, id) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.getAgentById(id).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getAgentList({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.getAgentList(dataParams).then(response => {
                // const { data } = response;
                if(response.data.data.length > 0){
                    response.data.data.forEach(i => {
                        i.full_name = i.first_name  + ' '+ i.last_name
                    })
                }
                commit("SET_fieldsGetAgentList", dataParams);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    createStored({ commit }, dataParams) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.createStored(dataParams).then(response => {
                // const { data } = response;
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    setAgentSession({ commit }, data) {
        commit("SET_agentSession", data);
    },
    setXAuthAgent({ commit }, data) {
        commit("SET_x_auth_agent", data);
    },
    connectToAgentOwner({ commit, state }, dataArr) {
        // Simpan sesi agent sebelumnya. Jika aktivasi lisensi gagal, sesi
        // aktif tidak boleh ikut hilang (mis. saat Lihat Chat gagal).
        const previousSession = state.agentSession || {};
        const previousToken = state.x_auth_agent || getXAuthAgent() || "";

        const restorePreviousSession = () => {
            commit("SET_agentSession", previousSession);
            commit("SET_x_auth_agent", previousToken);
            if (previousToken) {
                setXAuthAgent(previousToken);
            } else {
                removeXAuthAgent("");
            }
            if (previousSession && Object.keys(previousSession).length > 0) {
                setAgentSession(previousSession);
            } else {
                removeAgentSession({ "agentSession": {} });
            }
        };

        commit("SET_agentSession", {});
        commit("SET_x_auth_agent", "");
        removeXAuthAgent("");
        removeAgentSession({ "agentSession": {} });

        return new Promise((resolve, reject) => {
            const request = dataArr && dataArr.silent
                ? util.connectToAgentOwnerSilent(dataArr)
                : util.connectToAgentOwner(dataArr);

            request.then(response => {
                const { data } = response;
                const expectedLicenseId = dataArr && dataArr.license_id
                    ? String(dataArr.license_id)
                    : "";
                const responseLicenseId = data && data.license_id
                    ? String(data.license_id)
                    : "";

                if (!data || !data.token || (expectedLicenseId && responseLicenseId !== expectedLicenseId)) {
                    restorePreviousSession();
                    reject(new Error("Lisensi belum berhasil diaktifkan."));
                    return;
                }

                commit("SET_agentSession", data);
                commit("SET_x_auth_agent", data.token);
                setXAuthAgent(data.token)
                setAgentSession(data)

                resolve(response);
            }).catch(error => {
                restorePreviousSession();
                const apiMessage = error && error.response && error.response.data
                    ? error.response.data.msg
                    : "";
                reject(apiMessage ? new Error(apiMessage) : error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/agent.js